import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from '@sentry/react';
import { ClientPreview } from '~/components/ClientPreview/ClientPreview';
import { routes } from '~/constants';
import { matchOverviewStatus } from './RecentAgreements.utils';
export function navigateForRow(row, navigate, overlayContext, previewDraft) {
    function openPreviewForRelationship() {
        if (row.relationshipId == null) return warnMissingId(row);
        return openClientPreview(row.relationshipId, overlayContext);
    }
    matchOverviewStatus(row.status, {
        active: ()=>{
            if (row.relationshipId == null) return warnMissingId(row);
            return navigate(routes.agreementMinisiteRoutes(row.relationshipId).agreement);
        },
        paymentConnected: openPreviewForRelationship,
        reviewed: openPreviewForRelationship,
        sent: openPreviewForRelationship,
        // WHY: scheduled opens the draft preview (the client preview) via draftId — same as the drafts-table Preview; no relationshipId needed.
        scheduled: ()=>{
            if (row.draftId == null) return warnMissingId(row);
            void previewDraft(row.draftId);
        },
        draft: ()=>{
            if (row.draftId == null) return warnMissingId(row);
            return navigate(routes.draft(row.draftId));
        }
    });
}
export function openClientPreview(relationshipId, overlayContext) {
    overlayContext.showModal({
        biName: 'client_preview_modal',
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: (props)=>/*#__PURE__*/ _jsx(ClientPreview, _object_spread({
                type: "relationshipId",
                relationshipId: relationshipId
            }, props))
    });
}
function warnMissingId(row) {
    Sentry.captureMessage('Recent-agreement row clicked with missing routing id', {
        level: 'warning',
        tags: {
            context: 'useRecentAgreementNavigation_missing_id'
        },
        extra: {
            id: row.id,
            status: row.status
        }
    });
}
